/* eslint-disable */
import React from "react";
import styles from "./VideoDocument.module.css";
import PuiTypography from "../../../components/elements/PuiTypography";
import { VideoExtraMaterial } from "../../../models/video";
import FileIcon from "@material-ui/icons/InsertDriveFile";
import ShowFileIcon from "./ShowFileIcon";
import { saveAs } from "file-saver";
import useResponsive from "../../../common/useResponsive";

interface VideoDocumentProps {
  documentList: VideoExtraMaterial[];
}

export default function VideoDocument({ documentList }: VideoDocumentProps) {
  const DownloadDocument = (documentIndex: number) => {
    console.log("DownloadDocument start");
    console.log("documentList:", documentList);

    console.log("documentIndex:", documentIndex);
    const downloadUrl = "/api/video/material/" + documentList[documentIndex].id;
    const downloadName = documentList[documentIndex].fileName;

    console.log("downloadUrl:", downloadUrl);
    saveAs(downloadUrl, downloadName);
  };

  const { isMobile } = useResponsive();

  return (
    <div className={styles.videoMaterials}>
      <div className={styles.header}>
        <div className={styles.materialIcon}>
          <FileIcon />
        </div>

        <PuiTypography size={isMobile ? 16 : 20} bold={true}>
          Documents
        </PuiTypography>

        <div className={styles.materialCount}>
          <PuiTypography size={isMobile ? 16 : 20}>{String(documentList.length)}</PuiTypography>
        </div>
      </div>

      <div className={styles.videoMaterialsList}>
        {documentList &&
          documentList.map((document, index) => (
            <ShowFileIcon
              key={index}
              fileName={document.fileName}
              fileType={document.contentType}
              isVisibleFileName={true}
              documentIndex={index}
              DownloadDocument={DownloadDocument}
            />
          ))}
      </div>
    </div>
  );
}
